import axios from "axios";


const host = window.location.host;
export default axios.create({
    baseURL: `${host}:5000`,
    headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, DELETE"
    }
});